module.exports = ".list-group-item {\n  padding: 0 0.25rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/roles/components/permission.modal.scss
// module id = 584
// module chunks = 1